import React, { useState } from "react";

import plusIcon from "assets/img/icons8-plus-48.png";

import "./Sidebar.css";

function Sidebar(props) {
  const colors = ["#fe9b72", "#fec971", " #00d4fe", "#b693fd", "#e4ee91"];
  const { notes } = props;
  // Checking if notes array exists and has at least one element
  // const isUpdatedNotes = notes && notes.length > 0 ? notes[0].isUpdated : 0;

  const CheckIsUpdated = notes && notes.length > 0 ? notes[notes.length - 1].isUpdated : 0;
  console.log('Check Published ->', CheckIsUpdated);

  const [listOpen, setListOpen] = useState(false);

  return (
    <div className="sidebar">
      <img src={plusIcon} alt="Add" onClick={() => setListOpen(!listOpen)} />
      <ul className={`sidebar_list ${listOpen ? "sidebar_list_active" : ""}`}>
        {colors.map((item, index) => (
          <li
            key={index}
            className="sidebar_list_item"
            style={{ backgroundColor: item }}
            onClick={() => {
              props.addNote(item);
              setListOpen(false);
          }}
          />
        ))}
      </ul>

    </div>
  );
}

export default Sidebar;
